import { CivilDate } from 'tc39-proposal-temporal';

/**
 * isCivilDateGreaterThanEqual
 * @param {CivilDate} value - value
 * @param {CivilDate} date2 - date to compare against
 * @returns {bool} - is value > param
 */
export function isCivilDateGreaterThanEqual(value, date2) {
  const newDate1 = new Date(value.year, value.month - 1, value.day);
  const newDate2 = new Date(date2.year, date2.month - 1, date2.day);
  return !!(newDate1 >= newDate2);
}

/**
 * isCivilDateGreaterThan
 * @param {CivilDate} value - value
 * @param {CivilDate} date2 - date to compare against
 * @returns {bool} - is value > param
 */
export function isCivilDateGreaterThan(value, date2) {
  const newDate1 = new Date(value.year, value.month - 1, value.day);
  const newDate2 = new Date(date2.year, date2.month - 1, date2.day);
  return !!(newDate1 > newDate2);
}

const regex = /(\d*)-(\d*)-(\d*)/;
export function getCivilDateFromString(value) {
  const temp = regex.exec(value);
  return new CivilDate(temp[1], temp[2], temp[3]);
}

export function trimDate(value, today) {
  return isCivilDateGreaterThan(value, today) ?
    today :
    value;
}
